import { CANCEL_GUEST_SCHEDULED, LOAD } from 'model/guestLoanSearch';
import {
  loadByLoanNumber,
  loadByEmail,
  cancelGuestScheduledPayment,
} from 'sdk/guestLoanSearch';
import { takeLatest, call, put, takeEvery } from 'redux-saga/effects';
import { LOAD_HISTORY, LOAD_SCHEDULED } from '../model/guestLoanSearch';
import {
  loadHistoryTransactions,
  loadScheduledTransactions,
} from '../sdk/guestLoanSearch';
import { ADD_MESSAGE } from '../util/actions';

function* handleLoadHistory({ data }) {
  const { auth, ...rest } = data;
  try {
    const response = yield call(loadHistoryTransactions, rest, auth);
    const transactions = response?.payload?.items || [];
    yield put({
      type: LOAD_HISTORY.SUCCESS,
      data: { loanNumber: rest.loanNumber, transactions },
    });
  } catch (error) {
    yield put({
      type: LOAD_HISTORY.FAILURE,
      error: error.message,
      data: rest,
    });
  }
}

function* handleLoadScheduled({ data }) {
  const { auth, ...rest } = data;
  try {
    const response = yield call(loadScheduledTransactions, rest, auth);
    const transactions = response?.payload?.items || [];
    yield put({
      type: LOAD_SCHEDULED.SUCCESS,
      data: { loanNumber: rest.loanNumber, transactions },
    });
  } catch (error) {
    yield put({
      type: LOAD_SCHEDULED.FAILURE,
      error: error.message,
      data: rest,
    });
  }
}

export function* handleCancelScheduled({ data }) {
  const { userId, ...rest } = data;
  try {
    const response = yield call(cancelGuestScheduledPayment, rest, userId);

    yield put({
      type: CANCEL_GUEST_SCHEDULED.SUCCESS,
      data: {
        loanNumber: rest.loanNumber,
        scheduleId: rest.scheduleId,
      },
    });

    yield put({
      type: ADD_MESSAGE.ACTION,
      data: 'Payment successfully canceled',
    });

    // Reload scheduled transactions to get updated list
    yield put({
      type: LOAD_SCHEDULED.ACTION,
      data: {
        fspId: rest.fspId,
        loanNumber: rest.loanNumber,
        // auth removed, not needed for guest flow
      },
    });
  } catch (error) {
    yield put({
      type: CANCEL_GUEST_SCHEDULED.FAILURE,
      error: error.message,
      data: rest,
    });

    yield put({
      type: ADD_MESSAGE.ACTION,
      data: error.message || 'Failed to cancel payment',
    });
  }
}

function* loadGuestLoanSearchSaga(action) {
  try {
    const { data = {}, auth = {} } = action;
    const { loanNumber, email, fspId, limit, offset } = data;
    let response;
    if (loanNumber) {
      response = yield loadByLoanNumber({ fspId, loanNumber }, auth);
    } else if (email) {
      response = yield loadByEmail({ fspId, email, limit, offset }, auth);
    } else {
      throw new Error('Either loanNumber or email must be provided');
    }
    yield put({ type: LOAD.SUCCESS, data: { response } });
  } catch (error) {
    yield put({ type: LOAD.FAILURE, data: { error } });
  }
}

export default function* guestLoanSearchSaga() {
  yield takeEvery(LOAD.ACTION, loadGuestLoanSearchSaga);
  yield takeLatest(LOAD_HISTORY.ACTION, handleLoadHistory);
  yield takeLatest(LOAD_SCHEDULED.ACTION, handleLoadScheduled);
  yield takeEvery(CANCEL_GUEST_SCHEDULED.ACTION, handleCancelScheduled);
}
